import React from 'react';
import Datalayer from './Datalayer';
export var DatalayerScene = function DatalayerScene(_ref) {
  var pageType = _ref.pageType,
    pageId = _ref.pageId;
  var params = pageId ? {
    pageType: pageType,
    pageId: pageId
  } : {
    pageType: pageType
  };
  return React.createElement(React.Fragment, null, React.createElement(Datalayer, {
    id: "Scene",
    type: "ready",
    params: params
  }), React.createElement(Datalayer, {
    id: "Scene",
    type: "pageType",
    params: params
  }));
};
export default DatalayerScene;